export const IMAGE_SRC_KEY = ['src', 'backupSrc', 'embed'];
export const UNSET_KEY = ['chartRelation', 'chartStaticFolder'];
